export default "__VITE_ASSET__d60ecb79__"